import { useState } from "react";
import { toast } from "sonner";
import { Link2, Copy } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAdminApi, errMsg } from "@/lib/api";

export const shareUrl = (token) => `${window.location.origin}/d/${token}`;

export const copy = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    toast.success("Link copied");
  } catch {
    toast.message("Copy the link manually");
  }
};

export const ShareLinkDialog = ({ doc, onDone }) => {
  const call = useAdminApi();
  const [open, setOpen] = useState(false);
  const [recipient, setRecipient] = useState("");
  const [link, setLink] = useState(null);

  const create = async (e) => {
    e.preventDefault();
    try {
      const l = await call({ method: "post", url: `/admin/documents/${doc.id}/links`, data: { recipient } });
      setLink(l);
      onDone();
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  const reset = (o) => { setOpen(o); if (!o) { setLink(null); setRecipient(""); } };

  return (
    <Dialog open={open} onOpenChange={reset}>
      <DialogTrigger asChild>
        <button className="inline-flex items-center gap-1.5 rounded-full border border-stone-300 px-3 py-1.5 text-xs hover:bg-stone-100" data-testid={`doc-share-btn-${doc.id}`}>
          <Link2 className="h-3.5 w-3.5" /> Create 7-day link
        </button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader><DialogTitle>Share "{doc.title}"</DialogTitle></DialogHeader>
        {!link ? (
          <form onSubmit={create} className="space-y-4">
            <div className="space-y-2"><Label>Who is it for?</Label>
              <Input value={recipient} onChange={(e) => setRecipient(e.target.value)} required placeholder="Buyer company or name" data-testid="share-recipient-input" /></div>
            <button type="submit" className="rounded-full bg-emerald-900 text-white px-5 py-2.5 text-sm" data-testid="share-create-btn">Create link</button>
          </form>
        ) : (
          <div className="space-y-4" data-testid="share-link-result">
            <p className="text-sm text-stone-600">Send this link to {link.recipient}. It expires on {new Date(link.expires_at).toLocaleString()}.</p>
            <div className="flex gap-2">
              <Input readOnly value={shareUrl(link.token)} data-testid="share-link-url" />
              <button onClick={() => copy(shareUrl(link.token))} className="rounded-md border px-3" data-testid="share-copy-btn"><Copy className="h-4 w-4" /></button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
